var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 24.9629L27.4998 26.6242C26.7042 27.5051 25.6253 28 24.5002 28C23.3752 28 22.2962 27.5051 21.5006 26.6242C20.7039 25.7451 19.625 25.2515 18.5003 25.2515C17.3756 25.2515 16.2967 25.7451 15.5 26.6242M2 28H4.51182C5.24559 28 5.61248 28 5.95774 27.9161C6.26385 27.8417 6.55648 27.719 6.8249 27.5524C7.12765 27.3646 7.38708 27.102 7.90594 26.5767L26.7501 7.49924C27.9927 6.24121 27.9927 4.20155 26.7501 2.94352C25.5074 1.68549 23.4927 1.68549 22.2501 2.94352L3.40589 22.021C2.88704 22.5462 2.62761 22.8089 2.44208 23.1154C2.27759 23.3871 2.15638 23.6834 2.08289 23.9933C2 24.3428 2 24.7143 2 25.4571V28Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyEditor);
export default __webpack_public_path__ + "static/media/policy-editor.2697f8ec53625643da33aa18d5e18c2d.svg";
export { ForwardRef as ReactComponent };